module.exports = {
  "dof-gear": {
    "flexDirection": "row",
    "alignItems": "flex-start"
  },
  "dof-gear-gap": {
    "flex": 1,
    "height": "1"
  },
  "dof-gear-item": {
    "flexDirection": "column",
    "alignItems": "center"
  },
  "dof-gear-item-anchor": {
    "width": "40",
    "height": "20",
    "flexDirection": "column",
    "alignItems": "center",
    "overflow": "hidden",
    "borderTopLeftRadius": "4",
    "borderTopRightRadius": "4"
  },
  "dof-gear-item-anchor-angle": {
    "width": "28.2842712474619",
    "height": "28.2842712474619",
    "transformOrigin": "center",
    "transform": "translateY(-14.14213562373095px) rotateZ(45deg)"
  },
  "dof-gear-item-track": {
    "position": "relative"
  },
  "dof-gear-item-bar": {
    "position": "absolute",
    "bottom": 0
  },
  "dof-gear-item-gear": {
    "marginTop": "16",
    "fontSize": "24",
    "fontFamily": "Helvetica",
    "maxLines": 1,
    "textOverflow": "ellipsis"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-c58a7930!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-gear/index.vue
// module id = 535
// module chunks = 0 1